import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import '../../App.css';
// import '../css/bootstrap.min.css';
// import '../css/demo.css';
// import '../css/material-kit.css';
import '../../css/materialize.min.css';
// import '../css/general.css';
import {
  // BrowserRouter as Router,
  // Route,
  // Link,
  // Redirect,
} from 'react-router-dom';
import * as Thoughts from './Thoughts';

class Journal extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };

  }

  componentDidMount() {

  }

  render() {
    const posts = Thoughts.Thoughts.map((t) => {
      return (
        <Post key={t.title} title={t.title}
          paragraphs={t.paragraphs}
        />
      );
    });

    return (
      <div className="no-pad-bot section" id="index-banner"
        style={{
          height: "100vh",
          // background: "linear-gradient(180deg, rgba(113,11,146, 0.9) 0.1%, rgba(255,255,255, 0.9) 90%), white",
          background: "linear-gradient(rgba(0, 0, 0, 147.7) -22.9%, rgba(255, 255, 255, 8.3) 19%) % % / cover white",
          backgroundSize: "cover",
          overflowY: "auto",
        }}
      >
        <div className="container"
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            // height: "100%",
          }}>
          <div style={{paddingTop: 50}}>
            {posts}
          </div>
        </div>
      </div>
    );
  }
}

class Post extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // let i = 0;
    // const paragraphs = this.props.paragraphs.map((item) => {
    //   i += 1;
    //   return (
    //     <p key={i}>
    //       {item}
    //     </p>
    //   );
    // });

    return (
      <div style={{
        fontFamily: "Baskerville, 'Baskerville Old Face', 'Goudy Old Style', Garamond, 'Times New Roman', serif",
        maxWidth: 400,
        fontSize: 16,
        borderBottom: "1px dotted lightgrey"}} >
        <h3>{this.props.title}</h3>
        {this.props.paragraphs}
      </div>
    );

  }
}

export default Journal;



// WEBPACK FOOTER //
// ./src/components/journal/Journal.js